import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { RoutingModule } from '@x/ecommerce-shop/app/core/routing/routing.module';
import { PageLayoutModule } from '@x/ecommerce-shop/app/core/shop-ui/components/layout/page-layout';
import { ItemNotFoundComponent } from './item-not-found/item-not-found.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

@NgModule({
  declarations: [PageNotFoundComponent, ItemNotFoundComponent],
  imports: [CommonModule, PageLayoutModule, MatButtonModule, RoutingModule, RouterLink],
  exports: [PageNotFoundComponent, ItemNotFoundComponent],
})
export class NotFoundModule {}
